import { render, staticRenderFns } from "./FilterArea.vue?vue&type=template&id=bc5bdd70&scoped=true&"
import script from "./FilterArea.vue?vue&type=script&lang=js&"
export * from "./FilterArea.vue?vue&type=script&lang=js&"
import style0 from "./FilterArea.vue?vue&type=style&index=0&id=bc5bdd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5bdd70",
  null
  
)

export default component.exports